export default {
  userInfo: '/api/source/user/',
  checkIsMigrated: '/v1/checkIsMigrated',
  tokenExchange: '/v1/token/exchange',
  migrateAuto: '/v1/migrate/auto',
  migrateLink: '/v1/migrate/link',
  sso: 'https://access.uat.funimationtest.com/auth/realms/Funimation/protocol/openid-connect/auth?client_id=funimation-migration&response_type=code&scope=openid&prompt=login&redirect_uri=:redirectUri&state=:state',
};
